import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorRectangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 86,
	height: 70,
	viewBox: "0 0 86 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.0826 4H82L70.1927 61.6235L4 66L10.0826 4Z" })
});
export default SvgErrorRectangle;
